import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";

export default store => ({
  path: "trash-learning-courses",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "bin" */ "./components"),
      import(
        /* webpackChunkName: "bin" */ "./modules/LearningCoursesBinModule"
      ),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;
      const reducer = importedModule1.default;

      injectReducer(store, {
        key: "learningCoursesBin",
        reducer,
      });

      return component;
    })
  ),
  childRoutes: [],
});
